import {makeStyles} from '@material-ui/core/styles'
import Card from '@mui/material/Card';
import {AddIconButton, CancelButton, EditModeButton, Text} from '../../1elements'
import GarbageBinIconButton from '../../1elements/Buttons/IconButtons/GarbageBinIconButton'
import TablePaginationWrapper from '../../2compounds/Tables/TablePaginationWrapper'
import RejectButton from '../../1elements/Buttons/TextButtons/RejectButton'
import ApproveButton from '../../1elements/Buttons/TextButtons/ApproveButton'
import ButtonLayoutDiv from '../../4layout/ButtonLayoutDiv'
import ApproveModal from '../../2compounds/ApproveModal'
import RejectModal from '../../2compounds/RejectModal'
import {useState} from 'react'
import SaveButton from '../../1elements/Buttons/TextButtons/SaveButton'
import SelectApproverModal from '../SmartForm/SelectApproverModal'
import {useNavigate} from 'react-router-dom'

const DataGridCardApproval = ({children, heading, dataCount,
                          addActive, editActive, deleteActive,
                          currentPage, setCurrentPage,
                          onReject, onApprove, columns, setColumns, editable, approver, setApprover, onSubmit}) => {
    const classes = useStyles()
    const navigate = useNavigate()
    const [modalOpenApproval, setModalOpenApproval] = useState(false)
    const [modalOpenReject, setModalOpenReject] = useState(false)
    const openModalOpenApproval = () => {
        setModalOpenApproval(true)
    }
    const openModalOpenReject = () => {
        setModalOpenReject(true)
    }

    const [isApproverModalOpen, setIsApproverModalOpen] = useState(false)
    const onCancel = () => {
        navigate('/adminDashboard')
    }
    const onSave = () => {
        setIsApproverModalOpen(true)
    }

    return (
        <Card className={classes.root}>
            <div className={classes.headerDiv}>
                <Text type={'dashboardTodayHeader'}>{heading}</Text>
                {
                    dataCount > 0 && (
                        <div className={classes.buttonDiv}>
                            {addActive && (<AddIconButton onImportMode={addActive} onImportClick={()=>{}} />)}
                            {editActive && (<EditModeButton onEditMode={editActive} setOnEditMode={()=>{}}  />)}
                            {deleteActive && (<GarbageBinIconButton active={deleteActive} onClick={()=>{}} />)}
                        </div>
                    )
                }
            </div>

            <TablePaginationWrapper columns={columns} setColumns={setColumns} postsPerPage={50} totalPosts={dataCount}
                                    currentPage={currentPage} setCurrentPage={setCurrentPage}>
                {children}
            </TablePaginationWrapper>

            {
                (dataCount > 0 && editable && (
                    <>
                        <ButtonLayoutDiv>
                            <CancelButton onClick={()=> {setModalOpenApproval(false); onCancel()}}/>
                            <SaveButton onClick={()=>{setModalOpenApproval(false); onSave()}}/>
                        </ButtonLayoutDiv>
                        <SelectApproverModal isModalOpen={isApproverModalOpen} setIsModalOpen={setIsApproverModalOpen}
                                             approver={approver} setApprover={setApprover}
                                             onSubmit={onSubmit} dashboard />
                    </>
                ))
            }
            {
                (dataCount > 0 && !editable &&  (
                        <>
                            <ButtonLayoutDiv>
                                <RejectButton onClick={openModalOpenReject} />
                                <ApproveButton onClick={openModalOpenApproval} />
                            </ButtonLayoutDiv>
                            <ApproveModal open={modalOpenApproval} setOpen={setModalOpenApproval}
                                          approveHandler={()=>{setModalOpenApproval(false);onApprove()}} />
                            <RejectModal open={modalOpenReject} setOpen={setModalOpenReject}
                                         rejectHandler={(reason)=>{setModalOpenReject(false); onReject(reason)}} />
                        </>
                    ))
            }
        </Card>
    )
}

export default DataGridCardApproval

const useStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        padding: '20px 15px',
        height: '100%'
    },
    buttonDiv: {
        alignItems: 'center',
        alignSelf: 'flex-end',
        display: 'flex',
    },
    headerDiv: {
        alignItems: 'center',
        justifyContent: 'space-between',
        display: 'flex',
        marginBottom: '5px'
    }
})
